<template>
	<el-dialog
	title="新增项目信息"
	:visible.sync="visible"
	width="525px"
	:before-close="befclose" >
		<el-form ref="formId" :rules="rules" :model="project" class="bm bm-ver form-info" label-position="right" size="small" label-width="120px">
			<div class="bm bm-ver">
                    <el-row :gutter="10" class="dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="信息项目名称" style="width:100%" prop="projectName" 
                                :rules="{required: true, message: '请输入',trigger: 'change'}">
                                <el-input v-model="project.projectName" size="small" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="项目类型" style="width:100%" prop="projectType" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
                                <el-select style="width:100%" filterable placeholder="请选择" v-model="project.projectType" clearable size="small">
                                    <el-option label="自研" value="1"></el-option>
                                    <el-option label="套件" value="2"></el-option>
                                    <el-option label="其他" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-row :gutter="10" class="dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="项目负责人" style="width:100%" prop="managerName">
                                <el-input v-model="project.managerName" size="small" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="项目开始时间" style="width:100%" prop="startDate" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
                                <el-date-picker
                                    value-format="timestamp"
                                    style="width:100%"
                                    v-model="project.startDate"
                                    type="date"
                                    placeholder="请选择">
                                    </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-row :gutter="10" class="dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="项目结束时间" style="width:100%" prop="endDate" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
                                <el-date-picker
                                    value-format="timestamp"
                                    style="width:100%"
                                    v-model="project.endDate"
                                    type="date"
                                    placeholder="请选择">
                                    </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
            </div>			
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancel()">取消</el-button>
			<el-button :disabled="!finishShow" type="primary" @click="complete()">完成</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { setTimeout } from 'timers';
const R = require('ramda')
export default {
	props: {
		visible: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			//校验规则
            rules: {
            },
            project:{},
            finishShow:false,
            project:{
                "projectName": "",
                "projectType": "",
                "startDate": "",
                "endDate": "",
                "managerName": "",
                "managerCode": "",
                "creatorCode": this.$store.state.user.userInfo.personCode
            }
		}
    },
    watch:{
        project: {
			handler: function(newValue, oldValue) {
                this.$refs.formId.validate(valiede => {
                    if(valiede){
                        this.finishShow = valiede;
                    }
                })
			},
			immediate: false,
			deep: true
        },
        visible() {
            let flag = this.visible;
            if(this.$refs.formId) {
                this.$refs.formId.resetFields();
            }
        }
    },
	methods:{
		befclose(){
			this.$emit("befclose");
		},
		complete(){
			this.$emit("complete",this.project);
        },
        cancel(){
            this.$emit("befclose");
        }
	}
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__body {
		padding: 20px 20px;
		display: flex;
		align-items: center;
    	overflow: auto;
		.form-info{
			height: 100%;
			width: 100%;
			.dept-info{
                height: 45px;
                margin-bottom: 10px;
				.futurePrice{
                    position: relative;
                    .unit{
                        z-index: 100;
                        position: absolute;
                        top: 8px;
                        right: 40px;
                        font-size: 14px;
                        color: #969696;
                    }
                }
            }

			.device-list{
				.device-list-row {
					margin-top: 30px;
				}
				.device-list-row:first-child{
					margin-top: 0px;
				}
			}
			.device-title{
				margin-left: 20px;
				margin-bottom: 10px;
				font-size: 16px;
				line-height: 16px;
				color: #323232;
				.device-model{
					font-size: 12px;
					color: #969696;
					margin-left: 9px;
					line-height: 12px;
				}
			}
			.add-device{
				margin-left: 20px;
				margin-top: 20px;
				font-size: 14px;
				line-height: 14px;
				color: #409eff;
			}
			.device-info-row{
				border: solid 1px #dcdfe5;
				padding: 20px 20px 2px 20px;
				.price{
					font-size: 14px;
					line-height: 14px;
					color: #ff3507;
					margin-left: 30px;
				}
				.del-btn{
					height: 50px;
				}
			}
			.el-input--small .el-input__inner{
				height: 36px;
				line-height: 36px;
			}
			.el-input-number__increase, .el-input-number__decrease{
				top: 2px;
				height: 28px;
			}
		}
		
	}
}
</style>
